import {
    AfterViewInit, Component, ContentChild, ElementRef, Input, Output, OnDestroy, ViewChild,
    ViewEncapsulation, EventEmitter, ViewChildren, QueryList
} from '@angular/core';
import { Md2Datepicker } from 'md2';
import { bindFunctionsToThis } from '../../extensions';
import { DropDownTriggerComponent } from './trigger/drop.down.trigger.component';

@Component({
    selector: 'ig-drop-down',
    templateUrl: './drop.down.component.html',
    styleUrls: ['./drop.down.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DropDownComponent implements AfterViewInit, OnDestroy {
    public isShowing: boolean;
    @Input() place: 'top' | 'bottom' = 'bottom';
    @Input() align: 'left' | 'right' = 'left';
    @Input() public showDropDownItem: string;
    @Output() childEvent = new EventEmitter<any>();
    @Output() onDropdownShow = new EventEmitter<any>();
    @ContentChild(DropDownTriggerComponent, {read: ElementRef}) trigger: ElementRef;
    @ViewChild('container') container: ElementRef;
    @ViewChildren(Md2Datepicker) public datePickers: QueryList<Md2Datepicker>;

    constructor() {
        bindFunctionsToThis(this);
    }

    public ngAfterViewInit() {
        this.bindEvents();
    }

    public ngOnDestroy() {
        this.unbindEvents();
    }

    private bindEvents() {
        window.addEventListener('click', this.close);
        this.trigger.nativeElement.addEventListener('click', this.show);
    }

    private unbindEvents() {
        window.removeEventListener('click', this.close);
        this.trigger.nativeElement.removeEventListener('click', this.show);
    }

    public close(event?: Event) {
        if (!event) {
            this.isShowing = false;

            return;
        }

        if (((event.target as any).className == 'md2-datepicker-input'
                || (event.target as any).className == 'md2-calendar-body-cell-content')) {
            return;
        }

        let parentNode = (event.target as any).parentNode;

        while (parentNode != null && parentNode !== this.container.nativeElement) {
            parentNode = parentNode.parentNode;
        }

        this.isShowing = parentNode === this.container.nativeElement;
    }

    public show(event?: Event) {
        this.onDropdownShow.emit();
        if (this.showDropDownItem === 'false') {
            this.childEvent.emit();
            return;
        }
        event&&event.stopPropagation();
        let dropDownGap = 8;
        let container = this.container.nativeElement;
        let containerRect = container.getBoundingClientRect();
        let triggerRect = this.trigger.nativeElement.getBoundingClientRect();
        let top = triggerRect.height + dropDownGap;
        let left = 0;

        if (this.place === 'top') {
            top = -containerRect.height - dropDownGap;
        }

        if (this.align === 'right') {
            left = triggerRect.right - containerRect.width;
        }

        this.isShowing = true;
        container.style.left = `${left}px`;
        container.style.top = `${top}px`;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/drop.down.component.ts